// Origen de la visita, folio en WhatsApp y sensores de clics (S1 y S2, 19-oct-2026).
// Lo carga snippets/av-medicion.liquid en todas las páginas, con window.AV_MEDICION = { sensor, linea, idioma }.
//
// 1. Llegada: si la visita trae gclid, gbraid, wbraid, fbclid, msclkid o utm_*, o viene de otro dominio, se guarda
//    en el navegador (localStorage «av-origen») como ÚLTIMA llegada, y como PRIMERA si no había ninguna.
// 2. WhatsApp: al dar clic en cualquier enlace a wa.me o api.whatsapp.com se arma el folio
//    (AV-<línea>-<AAMMDD>-<4>, el mismo formato del cotizador, sin letra de canal), el mensaje dice «Mi folio: AV-…»
//    y el clic va al sensor (POST /entrada del servicio avantia-cotizaciones) con sendBeacon: no retrasa la apertura.
// 3. Llamar: cada clic en un enlace tel: va al sensor con el número marcado.
// 4. Página puente de Messenger (sections/av-puente-whatsapp.liquid): crea el folio, manda el evento y abre WhatsApp.
// 5. Cada evento se publica también para el píxel de «Eventos de clientes» (Shopify.analytics.publish, nombres
//    avantia:*), que lo reenvía con el clientId de Shopify (medicion/pixel-personalizado.js en el proyecto).
//
// Nada de esto puede romper la página: todo va en try/catch y, si algo falla, el enlace abre como siempre.
// Datos personales: aquí no se lee ni se manda nada de lo que escribe el cliente; sólo folio, página y origen.
// Cookies (S6, 19-oct): si la persona apagó «Análisis» en la franja (assets/av-cookies.js), no se guarda la llegada, no se
// manda el origen, no se mandan clics al sensor ni eventos al píxel. El folio sí sigue en el mensaje de WhatsApp: es la
// referencia de su solicitud. Cotizar y Contacto siguen mandando su solicitud, sin origen y con analitica = false.
(function () {
  'use strict';
  var CFG = window.AV_MEDICION || {};
  var CLAVE = 'av-origen', FIRMA = 'av-origen-firma', FOLIO_WA = 'av-folio-wa';
  var PARAMS = ['gclid', 'gbraid', 'wbraid', 'fbclid', 'msclkid', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
  var LINEAS = ['EX', 'NM', 'TE', 'TI', 'AC', 'PS', 'ES', 'LZ', 'OT', 'TD', 'DT', 'CG'];
  // Dominios que NO cuentan como llegada nueva: la propia tienda, Shopify (pago, vista previa) y pasarelas de pago.
  var PROPIOS = ['avantiametales.com', 'myshopify.com', 'shopify.com', 'shop.app', 'shopifypreview.com', 'paypal.com', 'mercadopago.com', 'mercadopago.com.mx'];
  var EN = /^en/i.test(CFG.idioma || document.documentElement.lang || '');
  var TXT = EN ? { hola: 'Hello.', folio: 'My reference: ' } : { hola: 'Hola.', folio: 'Mi folio: ' };

  function leer(almacen, k) { try { return JSON.parse(window[almacen].getItem(k) || 'null'); } catch (e) { return null; } }
  function escribir(almacen, k, v) { try { window[almacen].setItem(k, JSON.stringify(v)); } catch (e) {} }

  // Consentimiento: «no» si la persona apagó análisis en la franja de cookies (se lee aquí mismo, sin esperar a que cargue
  // la API de Shopify) o si la API de privacidad de Shopify ya cargó y dice que no. En México, sin elección, Shopify dice que sí.
  function permitido() {
    try { var c = JSON.parse(localStorage.getItem('av-cookies') || 'null'); if (c && c.analitica === false) return false; } catch (e) {}
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.analyticsProcessingAllowed === 'function') return cp.analyticsProcessingAllowed() !== false;
    } catch (e) {}
    return true;
  }
  try {
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function' && !window.Shopify.customerPrivacy) {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () {});
    }
  } catch (e) {}

  function propio(host) {
    if (!host) return true;
    host = host.toLowerCase();
    if (host === location.hostname.toLowerCase()) return true;
    for (var i = 0; i < PROPIOS.length; i++) {
      var d = PROPIOS[i];
      if (host === d || host.slice(-(d.length + 1)) === '.' + d) return true;
    }
    return false;
  }
  function dominioReferencia() {
    try { return document.referrer ? new URL(document.referrer).hostname.toLowerCase() : ''; } catch (e) { return ''; }
  }

  // ── 1. llegada ─────────────────────────────────────────
  function llegadaActual() {
    var q = new URLSearchParams(location.search), o = {}, hay = false;
    PARAMS.forEach(function (k) { var v = q.get(k); if (v) { o[k] = v.slice(0, 300); hay = true; } });
    var ref = dominioReferencia(), externo = ref && !propio(ref);
    if (!hay && !externo) return null;
    o.referencia = externo ? ref : '';
    o.entrada = location.pathname;
    o.fecha = new Date().toISOString();
    return o;
  }
  function registrarLlegada(l) {
    if (!l || !permitido()) return;
    // una recarga de la misma página de llegada no es otra llegada
    var firma = JSON.stringify([PARAMS.map(function (k) { return l[k] || ''; }), l.referencia, l.entrada]);
    try { if (sessionStorage.getItem(FIRMA) === firma) return; sessionStorage.setItem(FIRMA, firma); } catch (e) {}
    var o = leer('localStorage', CLAVE) || {};
    if (!o.primera) o.primera = l;
    o.ultima = l;
    escribir('localStorage', CLAVE, o);
  }
  function origen() {
    if (!permitido()) return null;
    var o = leer('localStorage', CLAVE);
    return o && (o.primera || o.ultima) ? { primera: o.primera || null, ultima: o.ultima || null } : null;
  }

  // ── folio y envío al sensor ────────────────────────────
  function nuevoFolio(linea) {
    var d = new Date(), A = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789', c = '', p2 = function (v) { return String(v).padStart(2, '0'); };
    var r = new Uint8Array(4);
    try { crypto.getRandomValues(r); } catch (e) { for (var j = 0; j < 4; j++) r[j] = Math.floor(Math.random() * 256); }
    for (var i = 0; i < 4; i++) c += A[r[i] % A.length];
    if (LINEAS.indexOf(linea) < 0) linea = 'CG';
    return 'AV-' + linea + '-' + p2(d.getFullYear() % 100) + p2(d.getMonth() + 1) + p2(d.getDate()) + '-' + c;
  }
  // El mismo folio para los clics a WhatsApp de la misma línea durante 30 min (si regresa y vuelve a dar clic).
  function folioWhatsApp(linea) {
    var f = leer('sessionStorage', FOLIO_WA);
    if (f && f.linea === linea && Date.now() - f.t < 30 * 60 * 1000) return f.folio;
    var folio = nuevoFolio(linea);
    escribir('sessionStorage', FOLIO_WA, { folio: folio, linea: linea, t: Date.now() });
    return folio;
  }
  function nuevoId() {
    try { if (crypto.randomUUID) return crypto.randomUUID(); } catch (e) {}
    return 'av-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
  }
  function publicar(tipo, datos) {
    try { if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') Shopify.analytics.publish('avantia:' + tipo, datos); } catch (e) {}
  }
  // Manda el evento al sensor sin esperar respuesta. text/plain = sin preflight de CORS.
  function enviar(tipo, extra) {
    var cuerpo = { tipo: tipo, fuente: 'tema', evento_id: nuevoId(), pagina: location.pathname, idioma: CFG.idioma || document.documentElement.lang || '' };
    for (var k in extra) if (Object.prototype.hasOwnProperty.call(extra, k)) cuerpo[k] = extra[k];
    if (!permitido()) return cuerpo; // análisis apagado: ni sensor ni píxel
    var o = origen();
    if (o) { cuerpo.primera = o.primera; cuerpo.ultima = o.ultima; }
    publicar(tipo, { folio: cuerpo.folio || '', evento_id: cuerpo.evento_id, numero_destino: cuerpo.numero_destino || '', pagina: cuerpo.pagina });
    var url = CFG.sensor;
    if (!url) return cuerpo;
    var datos = JSON.stringify(cuerpo);
    try { if (navigator.sendBeacon && navigator.sendBeacon(url, datos)) return cuerpo; } catch (e) {}
    try { fetch(url, { method: 'POST', body: datos, keepalive: true, mode: 'no-cors', headers: { 'content-type': 'text/plain;charset=UTF-8' } }).catch(function () {}); } catch (e) {}
    return cuerpo;
  }
  var nacional = function (num) { var d = String(num || '').replace(/\D/g, ''); return d.length > 10 ? d.slice(-10) : d; };

  // ── 2 y 3. clics a WhatsApp y Llamar ───────────────────
  function numeroDe(u) {
    if (/wa\.me$/i.test(u.hostname)) return u.pathname.replace(/\D/g, '');
    return (u.searchParams.get('phone') || '').replace(/\D/g, '');
  }
  function mensaje(previo, folio) {
    // si el botón ya traía un texto (p. ej. el de Contacto), se respeta y el folio va al final
    previo = String(previo || '').replace(/\s+$/, '');
    var base = previo ? previo + (/[.!?]$/.test(previo) ? ' ' : '. ') : TXT.hola + ' ';
    return base + TXT.folio + folio;
  }
  function urlWhatsApp(num, texto) { return 'https://wa.me/' + num + '?text=' + encodeURIComponent(texto); }

  function clicWhatsApp(a) {
    if (a.hasAttribute('data-av-puente-boton')) return; // el botón de la página puente ya lleva su folio y su evento
    var original = (a.getAttribute('data-av-href') || a.getAttribute('href') || '').trim();
    a.setAttribute('data-av-href', original);
    var u = new URL(original, location.href), num = numeroDe(u);
    if (!num) return;
    var linea = a.getAttribute('data-av-linea') || CFG.linea || 'CG';
    var folio = folioWhatsApp(linea);
    a.href = urlWhatsApp(num, mensaje(u.searchParams.get('text'), folio));
    enviar('clic_whatsapp', { folio: folio, numero_destino: nacional(num) });
  }
  function clicLlamar(a) {
    enviar('clic_llamar', { numero_destino: nacional((a.getAttribute('href') || '').trim()) });
  }
  // En captura: corre antes que cualquier otro script y antes de que el navegador abra el enlace (que usa el href
  // ya cambiado). Nunca se cancela el clic.
  document.addEventListener('click', function (e) {
    try {
      var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
      if (!a) return;
      // trim: el href de la cabecera sale de un capture de Liquid y empieza con un salto de línea
      var h = (a.getAttribute('href') || '').trim();
      if (/^tel:/i.test(h)) clicLlamar(a);
      else if (/^(https?:)?\/\/(wa\.me|api\.whatsapp\.com)\//i.test(h)) clicWhatsApp(a);
    } catch (err) {}
  }, true);

  // ── 4. página puente (enlace fijo del asistente de Messenger) ──
  function puente() {
    var box = document.querySelector('[data-av-puente]');
    if (!box) return;
    var q = new URLSearchParams(location.search);
    var canal = String(q.get('origen') || q.get('utm_source') || 'messenger').toLowerCase().replace(/[^a-z0-9_-]/g, '').slice(0, 30) || 'messenger';
    var ref = dominioReferencia();
    // El enlace del asistente es una llegada nueva de ese canal (aunque el navegador de Messenger no diga de dónde viene).
    if (!q.get('utm_source')) {
      registrarLlegada({ utm_source: canal, utm_medium: 'enlace-whatsapp', referencia: ref && !propio(ref) ? ref : '', entrada: location.pathname, fecha: new Date().toISOString() });
    }
    var num = String(box.getAttribute('data-wa') || '').replace(/\D/g, '');
    if (num.length === 10) num = '52' + num;
    if (!num) return;
    var folio = nuevoFolio('CG');
    var url = urlWhatsApp(num, mensaje('', folio));
    var f = box.querySelector('[data-av-folio]'); if (f) f.textContent = folio;
    var b = box.querySelector('[data-av-puente-boton]'); if (b) b.href = url;
    box.classList.add('listo');
    enviar(canal === 'messenger' ? 'messenger_enlace' : 'clic_whatsapp', { folio: folio, numero_destino: nacional(num) });
    // Un instante para que se vea el folio y salga el aviso; luego abre WhatsApp. Si el navegador no lo abre, queda el botón.
    // ?abrir=no deja ver la página sin saltar a WhatsApp (para revisarla).
    if (!box.hasAttribute('data-sin-abrir') && q.get('abrir') !== 'no') setTimeout(function () { try { location.href = url; } catch (e) {} }, 600);
  }

  // ── arranque ───────────────────────────────────────────
  // En la página puente la llegada la anota puente() con su canal, salvo que el enlace ya traiga utm_source.
  try {
    if (!document.querySelector('[data-av-puente]') || new URLSearchParams(location.search).get('utm_source')) registrarLlegada(llegadaActual());
  } catch (e) {}
  try { puente(); } catch (e) {}

  // Para Cotizar (av-fusion.js) y Contacto (av-contacto.js): el origen va con su folio al servicio, y el píxel recibe
  // el evento con el mismo evento_id para juntar la fila del servicio con el clientId de Shopify.
  window.AvMedicion = {
    origen: origen,
    folio: nuevoFolio,
    enviar: enviar,
    formulario: function (tipo, folio) {
      var id = nuevoId(), ok = permitido();
      if (ok) publicar(tipo, { folio: folio, evento_id: id, numero_destino: '', pagina: location.pathname });
      return { origen: ok ? origen() : null, evento_id: id, idioma: CFG.idioma || document.documentElement.lang || '', analitica: ok };
    },
    permitido: permitido,
  };
})();
